import { ReminderEmailService } from "@/common/api.service"
import { FETCH_REMINDER_EMAIL_TEMPLATE, FETCH_INDIVIDUAL_REMINDER_EMAIL_TEMPLATE, ADD_REMINDER_EMAIL_TEMPLATE, UPDATE_REMINDER_EMAIL_TEMPLATE,RESET_STATE, SEND_REMINDER_TEST_MAIL, DELETE_REMINDER_EMAIL_TEMPLATE } from "./actions.type"
import { SET_REMINDER_EMAIL, SET_INDIVIDUAL_REMINDER_EMAIL, SET_ERROR_REMINDER_EMAIL,STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        reminderemail: [],
        individualreminderemail: [],
        reminderemailerrors: null,
    }
}

let state = initialState()

const getters = {
    reminderemail(state) {
        return state.reminderemail
    },
    individualreminderemail(state) {
        return state.individualreminderemail
    }
}

const actions = {
    async [FETCH_REMINDER_EMAIL_TEMPLATE](context, slug) {
        const { data } = await ReminderEmailService.get(slug)
        context.commit(SET_REMINDER_EMAIL, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_REMINDER_EMAIL_TEMPLATE](context, slug) {
        const { data } = await ReminderEmailService.get(slug)
        context.commit(SET_INDIVIDUAL_REMINDER_EMAIL, data.data)
        return data;
    },  
    async [SEND_REMINDER_TEST_MAIL](context, payload) {
        return await ReminderEmailService.test(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_REMINDER_EMAIL, error.response.data.errors)
        });
    },  
    async [ADD_REMINDER_EMAIL_TEMPLATE](context, payload) {
        return await ReminderEmailService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_REMINDER_EMAIL, error.response.data.errors)
        });
    },     
    async [UPDATE_REMINDER_EMAIL_TEMPLATE](context, payload) {
        return await ReminderEmailService.update(payload, payload.id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_REMINDER_EMAIL, error.response.data.errors)
        });
    },  
    async [DELETE_REMINDER_EMAIL_TEMPLATE] (context, id) {
        return await ReminderEmailService.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_REMINDER_EMAIL, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_REMINDER_EMAIL](state, error) {
        state.reminderemailerrors = error
    },      
    [SET_REMINDER_EMAIL](state, reminderemaildata) {
        state.reminderemail = reminderemaildata
    },
    [SET_INDIVIDUAL_REMINDER_EMAIL](state, individualreminderemaildata) {
        state.individualreminderemail = individualreminderemaildata
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};